import { serializer } from '@/api/shared/serializer';
import { batchUpdate } from '@/utils/batchUpdate';
import * as firebase from 'firebase/app';
import { getStaffAccessLevels } from "@/utils/accessControl/getAccessLevelDisplayName";
import { StaffAccessLevels } from "@/enums/StaffAccessLevels";

export default {
  name: 'InviteUsersDialog',
  components: {},
  data() {
    return {
      dialog: false,
      loading: true,
      importing: false,
      uninvitedUsers: [],
      search: '',
      headers: [
        {
          text: '',
          align: '',
          sortable: false,
          value: 'name',
        },
         {
          text: '',
          align: '',
          sortable: false,
          value: 'facilities',
        },
        {
          text: '',
          align: '',
          sortable: false,
          value: 'accessLevel',
        },
        {
          text: '',
          align: '',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  computed: {
    anySelected() {
      return this.uninvitedUsers.some(x => x.import === true)
    },
    currentUser() {
      return this.$store.state.authModule.user;
    },
    isHomeAdmin() {
      return this.currentUser.accessLevel === StaffAccessLevels.HomeAdmin;
    },
    facilitiesForOrg(){
      const allFacilities = this.$store.state.userModule.facilitiesForOrg;
      // Filter facilities for Home Admins - only show facilities they have access to
      if (this.isHomeAdmin && this.currentUser.facilitiesIds) {
        return allFacilities.filter(facility => 
          this.currentUser.facilitiesIds.includes(facility.id)
        );
      }
      return allFacilities;
    },
    accessLevels() {
      const hasMaintenanceFeature = this.$store.state.authModule.currentFacilityData.featureMaintenance;
      const allAccessLevels = getStaffAccessLevels(false, hasMaintenanceFeature);
      // Filter access levels for Home Admins - exclude only Org Admin
      if (this.isHomeAdmin) {
        return allAccessLevels.filter(level => 
          level.value !== StaffAccessLevels.OrgAdmin
        );
      }
      return allAccessLevels;
    },
    showSelectAll() { 
      return this.displayedUsers.length > 1 
    },
    displayedUsers() {
      const q = (this.search || '').trim().toLowerCase();
      if (!q) return this.uninvitedUsers;

      const hit = (v: any) => String(v ?? '').toLowerCase().includes(q);

      return this.uninvitedUsers.filter(u =>
        hit(u.name) ||
        hit(u.email)
      );
    }
  },
  methods: {
    async open(facilityId, orgId) {
      this.dialog = true;
      await this.$store.dispatch("getFacilitiesForOrg", orgId);
      this.uninvitedUsers = serializer.querySnapshotToDocuments<any>(
          await firebase.firestore().collection('users')
          .where('facilityId', '==', facilityId).where('orgId', '==', orgId).where('refOrigin', '==', 'rci').get()
        ).filter(x => !x.invitationSent).map(user => ({
        ...user,
        _search: '',
      }));
      this.loading = false;
    },
    close() {
      this.loading = false;
      this.importing = false;
      this.dialog = false;
      this.search = ''
    },
    async importUsers() {
      this.importing = true;

      const itemsToUpdate = this.uninvitedUsers
        .filter(x => x.import === true)
        .map(x => ({
          docId: x.id,
          updates: {
            accessLevel: x.accessLevel,
            invitationSent: true,
            facilities: this.facilitiesForOrg.filter(f=> x.facilitiesIds.includes(f.id)).map(x=>({id: x.id, name: x.name})),
            facilitiesIds: x.facilitiesIds
          },
        }));

      console.log('itemsToUpdate: ', itemsToUpdate.length);

      await batchUpdate('users', itemsToUpdate)
        .then(() => {
          this.$toast.open({
            message: `Invitation has been sent to ${itemsToUpdate.length} user${
              itemsToUpdate.length > 1 ? 's' : ''
            }`,
            type: 'success'
          });
          this.close();
        })
        .catch(error => {
          this.close();
          this.$toast.open({
            message: error,
            type: 'Unhandled error',
          });
        });
    },
    selectAll(value: boolean) {
      const visibleIds = new Set(this.displayedUsers.map(u => u.id));
      this.uninvitedUsers = this.uninvitedUsers.map(u =>
        visibleIds.has(u.id) ? { ...u, import: value } : u
      );
    }
  }
};
